module.exports = __webpack_public_path__ + "img/reloj-duo-2.8bc7ae69.svg";